"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailableDateGroupsForStats = exports.shouldOnlyShowAverageOfSeries = exports.isSortingAllowed = exports.isHardCodedStatistic = exports.assertIsAvailableStat = void 0;
var insightsReports_1 = require("../items/insightsReports");
var constants_1 = require("./constants");
function assertIsAvailableStat(stat) {
    return Object.values(constants_1.availableStats).includes(stat);
}
exports.assertIsAvailableStat = assertIsAvailableStat;
function isHardCodedStatistic(statistic) {
    return (constants_1.hardCodedStatistics.includes(statistic) &&
        !constants_1.singleMetricStatistics.includes(statistic));
}
exports.isHardCodedStatistic = isHardCodedStatistic;
function isSortingAllowed(opts) {
    // sorting is disabled when there's more than one series.
    if (opts.stats.length !== 1) {
        return {
            allowed: false,
            disableReason: 'manyStats'
        };
    }
    if (opts.groupBy.groupByKey === 'date' &&
        !['dayOfWeek', 'timeOfDay', 'monthOfYear'].includes(opts.groupBy.groupByValue)) {
        return {
            allowed: false,
            disableReason: 'groupedByDate'
        };
    }
    return {
        allowed: true
    };
}
exports.isSortingAllowed = isSortingAllowed;
function shouldOnlyShowAverageOfSeries(opts) {
    if (opts.isEngagementReport) {
        // In engagement reports, when grouping by something other than a date,
        // I don't want the total to show: due to how grouping works, there will be
        // rows that weren't matched to a category (e.g. a row for a user that didn't belong
        // to any user list) therefore, the only reliable totals are the ones you get
        // when grouping by a date (every row has a date - wait that's not true, for instance
        // for favourited entities...)
        var notGroupedByDate = !insightsReports_1.cGroupByDateOpts.includes(opts.value.averageByValue);
        return notGroupedByDate;
    }
    var ratioStats = [
        'externalInteractions_attendedToInvitedRatio',
        'externalInteractions_rsvpToInvitedRatio'
    ];
    if (opts.underlyingSeriesStatistic &&
        ratioStats.includes(opts.underlyingSeriesStatistic)) {
        return true;
    }
    return false;
}
exports.shouldOnlyShowAverageOfSeries = shouldOnlyShowAverageOfSeries;
function getAvailableDateGroupsForStats(opts) {
    return insightsReports_1.cGroupByDateOpts.filter(function (dateGroup) {
        var statHasRestrictedDateGroups = opts.statistics.some(function (statName) {
            var unavailableDateGroupsForStat = insightsReports_1.cUnavailableDateGroupsByStatistics[statName];
            if (!unavailableDateGroupsForStat) {
                return false;
            }
            if (!unavailableDateGroupsForStat.includes(dateGroup)) {
                return false;
            }
            return true;
        });
        return !statHasRestrictedDateGroups;
    });
}
exports.getAvailableDateGroupsForStats = getAvailableDateGroupsForStats;
